<template>
    <div class="card position-sticky top-1 mt-4">
      <ul class="nav flex-column bg-white border-radius-lg p-3">        
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#info">
            <i class="material-symbols-rounded text-lg me-2">person_pin_circle</i>
            <span class="text-sm">{{ $t('location.Location_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#contact">
            <i class="material-symbols-rounded text-lg me-2">contacts</i>
            <span class="text-sm">{{ $t('location.Contact_address_details') }}</span>
          </a>
        </li>
        <!--li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#rvo">
            <i class="material-symbols-rounded text-lg me-2">card_membership</i>
            <span class="text-sm">{{ $t('location.RVO') }}</span>
          </a>
        </li>     
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#toiler">
            <i class="material-symbols-rounded text-lg me-2">wash</i>
            <span class="text-sm">{{ $t('location.Toiler_disease_free') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#scrapie">
            <i class="material-symbols-rounded text-lg me-2">verified_user</i>
            <span class="text-sm">{{ $t('location.Scrapie') }}</span>
          </a>
        </li-->
        <li class="nav-item pt-2" v-show="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('location.Delete_location') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditLOcationSideNav",
    computed: {    
        userRoleName() {
            return this.$store.state.user?.roleName;
        }        
    },
  };
  </script>
  